export const ROMANIA_DESCRIPTION_LIST_REQUEST =
  "ROMANIA_DESCRIPTION_LIST_REQUEST";
export const ROMANIA_DESCRIPTION_LIST_SUCCESS =
  "ROMANIA_DESCRIPTION_LIST_SUCCESS";
export const ROMANIA_DESCRIPTION_LIST_FAIL = "ROMANIA_DESCRIPTION_LIST_FAIL";

export const ROMANIA_DESCRIPTION_UPDATE_REQUEST =
  "ROMANIA_DESCRIPTION_UPDATE_REQUEST";
export const ROMANIA_DESCRIPTION_UPDATE_SUCCESS =
  "ROMANIA_DESCRIPTION_UPDATE_SUCCESS";
export const ROMANIA_DESCRIPTION_UPDATE_FAIL =
  "ROMANIA_DESCRIPTION_UPDATE_FAIL";
export const ROMANIA_DESCRIPTION_UPDATE_RESET =
  "ROMANIA_DESCRIPTION_UPDATE_RESET";
